<div [formGroup]="parts">

  <mat-select  formControlName="selectedId" [compareWith]="compareFn"  >


    <mat-option *ngIf="hasNone" value="NONE" disable>
      Selecione uma opção
    </mat-option>
    <mat-option *ngFor="let item of options" [value]="item.id">
      {{item.name}}
    </mat-option>
  </mat-select>

</div>